import {
  SEARCHING_ASSET,
  SEARCHING_ASSET_SUCCEDDED,
  SEARCHING_ASSET_FAILED,
  INVALIDATE_ASSET_SEARCH_RESULT,
  SEARCHING_STREAM,
  SEARCHING_STREAM_SUCCEDDED,
  SEARCHING_STREAM_FAILED,
  INVALIDATE_STREAM_SEARCH_RESULT,
  SEARCHING_GROUP,
  SEARCHING_GROUP_SUCCEDDED,
  SEARCHING_GROUP_FAILED,
  INVALIDATE_GROUP_SEARCH_RESULT,
  SEARCHING_COLLECTION,
  SEARCHING_COLLECTION_SUCCEDDED,
  SEARCHING_COLLECTION_FAILED,
  INVALIDATE_COLLECTION_SEARCH_RESULT,
  SEARCHING_CONTACT,
  SEARCHING_CONTACT_SUCCEDDED,
  SEARCHING_CONTACT_FAILED,
  INVALIDATE_CONTACT_SEARCH_RESULT,
  SEARCHING_CONTACT_LIST,
  SEARCHING_CONTACT_LIST_SUCCEDDED,
  SEARCHING_CONTACT_LIST_FAILED,
  INVALIDATE_CONTACT_LIST,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED,
  INVALIDATE_AUTOCOMPLETE_CONTACT,
  FETCHING_TAGS,
  FETCHING_TAGS_SUCCEDDED,
  FETCHING_TAGS_FAILED,
  INVALIDATE_TAGS,
  SEARCHING_ASSET_DETAIL,
  SEARCHING_ASSET_DETAIL_SUCCEDDED,
  SEARCHING_ASSET_DETAIL_FAILED,
  INVALIDATE_ASSET_DETAIL_SEARCH_RESULT,
  SEARCHING_USERS_REQUEST,
  SEARCHING_USERS_SUCCEDDED,
  SEARCHING_USERS_FAILED,
  SEARCHING_USER_GROUPS_REQUEST,
  SEARCHING_USER_GROUPS_SUCCEDDED,
  SEARCHING_USER_GROUPS_FAILED,
  INVALIDATE_AUTOCOMPLETE_USER_GROUP,
  NOTIFY_CONTENT_MODERATOR_REQUEST,
  NOTIFYING_CONTENT_MODERATOR_SUCCEEDED,
  NOTIFYING_CONTENT_MODERATOR_FAILED,
  RECORDING_SEARCH_QUERY_REQUEST,
  RECORDING_SEARCH_QUERY_SUCCEDDED,
  RECORDING_SEARCH_QUERY_FAILED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED,
  SEARCHING_COMPANIES,
  SEARCHING_COMPANIES_SUCCEDDED,
  SEARCHING_COMPANIES_FAILED,
  INVALIDATE_COMPANIES_SEARCH_RESULT,
  SEEK_ANSWER_FOR_QUESTION_REQUEST,
  SEEK_ANSWER_FOR_QUESTION_SUCCEEDED,
  SEEK_ANSWER_FOR_QUESTION_FAILED,
  FETCHING_SEEKQA_SESSIONS,
  FETCHING_SEEKQA_SESSIONS_SUCCEEDED,
  FETCHING_SEEKQA_SESSIONS_FAILED,
  FETCHING_SEEKQA_CHATS,
  FETCHING_SEEKQA_CHATS_SUCCEEDED,
  FETCHING_SEEKQA_CHATS_FAILED,
  DELETING_SEEKQA_SESSION,
  DELETING_SEEKQA_SESSION_SUCCEEDED,
  DELETING_SEEKQA_SESSION_FAILED,
  DELETING_SEEKQA_SESSIONS,
  DELETING_SEEKQA_SESSIONS_SUCCEEDED,
  DELETING_SEEKQA_SESSIONS_FAILED,
  FETCHING_SEEKQA_SUGGESTIONS,
  FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED,
  FETCHING_SEEKQA_SUGGESTIONS_FAILED,
  INVALIDATE_SEEK_SESSION,
  UPDATING_SEEK_HELPFUL_FAILED,
  UPDATING_SEEK_HELPFUL_SUCCEEDED,
  UPDATING_SEEK_HELPFUL,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED,
  FETCHING_SEEK_LIMIT,
  FETCHING_SEEK_LIMIT_FAILED,
  FETCHING_SEEK_LIMIT_SUCCEEDED,
  FETCHING_SEEK_QUESTION_COUNT,
  FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED,
  FETCHING_SEEK_QUESTION_COUNT_FAILED

} from "./actionTypes"

import axios from "axios";
import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const SEARCH_BASE_URL = `${apiUrl}/api/2.0/search`;
const CONTACT_BASE_URL = `${apiUrl}/api/2.0/contacts`;
const USER_GROUPS_URL = `${apiUrl}/api/2.0/user_groups`;
const ORGANIZATION_BASE_URL = `${apiUrl}/api/2.0/organizations`;

const CRM_BASE_URL = `${apiUrl}/api/2.0/crm`;
const SEEK_URL = `${apiUrl}/api/2.0/seek`;
const INTEGRATION_BASE_URL = `${apiUrl}/api/2.1/integrations`;

/*
 * Search Asset
 */
export function searchAsset(query, filter, page, limit, highlight, searchWithinHub) {
  return function (dispatch) {
    dispatch(searchingAsset(query, page));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `assets/${page}`,
    });

    var additionalFilters = filter || {};

    var streams = [];
    if (filter && filter.streams) {
      streams = filter.streams;
    }

    var customFields = null;
    if (filter && filter.customFields) {
      customFields = JSON.stringify(filter.customFields);
    }
    let param = {
      ...additionalFilters,
      query: query,
      limit: limit,
      streams: streams,
      customFields: customFields,
      highlight: highlight,
      searchWithinHub: searchWithinHub
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingAssetSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingAssetFailed(query));
      });
  };
}

function searchingAsset(query, page) {
  return {
    type: SEARCHING_ASSET,
    payload: {
      query: query,
      currentPage: page,
    },
  };
}

function searchingAssetSuccedded(query, response) {
  return {
    type: SEARCHING_ASSET_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingAssetFailed(query) {
  return {
    type: SEARCHING_ASSET_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateAssetSearchResult() {
  return {
    type: INVALIDATE_ASSET_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search collection
 */

export function searchCollections(query, filter, page, limit, highlight) {
  return function (dispatch) {
    dispatch(searchingCollections(query));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `collections/${page}`,
    });

    var additionalFilters = filter || {};
    let param = {
      ...additionalFilters,
      query: query,
      limit: limit,
      highlight: highlight,
      includeDealRoom: false
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingCollectionsSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingCollectionsFailed(query));
      });
  };
}

function searchingCollections(query) {
  return {
    type: SEARCHING_COLLECTION,
    payload: {
      query: query,
    },
  };
}

function searchingCollectionsSuccedded(query, response) {
  return {
    type: SEARCHING_COLLECTION_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingCollectionsFailed(query) {
  return {
    type: SEARCHING_COLLECTION_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateCollectionsSearchResult() {
  return {
    type: INVALIDATE_COLLECTION_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search stream
 */

export function searchStreams(query, filter, page, limit, highlight) {
  return function (dispatch) {
    dispatch(searchingStreams(query));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `streams/${page}`,
    });

    var additionalFilters = filter || {};

    let param = {
      ...additionalFilters,
      query: query,
      limit: limit,
      highlight: highlight,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingStreamsSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingStreamsFailed(query));
      });
  };
}

function searchingStreams(query) {
  return {
    type: SEARCHING_STREAM,
    payload: {
      query: query,
    },
  };
}

function searchingStreamsSuccedded(query, response) {
  return {
    type: SEARCHING_STREAM_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingStreamsFailed(query) {
  return {
    type: SEARCHING_STREAM_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateStreamsSearchResult() {
  return {
    type: INVALIDATE_STREAM_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search group
 */

export function searchGroups(query, filter, page, limit, highlight) {
  return function (dispatch) {
    dispatch(searchingGroups(query));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `groups/${page}`,
    });

    var additionalFilters = filter || {};

    var streams = [];
    if (filter && filter.streams) {
      streams = filter.streams;
    }

    let param = {
      ...additionalFilters,
      query: query,
      limit: limit,
      streams: streams,
      highlight: highlight,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingGroupsSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingGroupsFailed(query));
      });
  };
}

function searchingGroups(query) {
  return {
    type: SEARCHING_GROUP,
    payload: {
      query: query,
    },
  };
}

function searchingGroupsSuccedded(query, response) {
  return {
    type: SEARCHING_GROUP_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingGroupsFailed(query) {
  return {
    type: SEARCHING_GROUP_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateGroupsSearchResult() {
  return {
    type: INVALIDATE_GROUP_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search contact
 */
export function searchContacts(query, global, page, limit, highlight) {
  return function (dispatch) {
    dispatch(searchingContacts(query, global, page));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `contacts/${page}`,
    });

    let param = {
      query: query,
      limit: limit,
      global: global,
      highlight: highlight,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingContactsSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingContactsFailed(query));
      });
  };
}

function searchingContacts(query, global, page) {
  return {
    type: SEARCHING_CONTACT,
    payload: {
      query: query,
      currentPage: page,
      global: global,
    },
  };
}

function searchingContactsSuccedded(query, response) {
  return {
    type: SEARCHING_CONTACT_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingContactsFailed(query) {
  return {
    type: SEARCHING_CONTACT_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateContactsSearchResult() {
  return {
    type: INVALIDATE_CONTACT_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search contact
 */
export function searchCompanies(query, page, limit) {
  return function (dispatch) {
    dispatch(searchingCompanies(query, page));

    let param = {
      query: query,
      page: page,
      limit: limit,
    };

    return axios({
      method: "GET",
      url: ORGANIZATION_BASE_URL,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingCompaniesSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingCompaniesFailed(query));
      });
  };
}

function searchingCompanies(query, page) {
  return {
    type: SEARCHING_COMPANIES,
    payload: {
      query: query,
      currentPage: page,
    },
  };
}

function searchingCompaniesSuccedded(query, response) {
  return {
    type: SEARCHING_COMPANIES_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingCompaniesFailed(query) {
  return {
    type: SEARCHING_COMPANIES_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateCompaniesSearchResult() {
  return {
    type: INVALIDATE_COMPANIES_SEARCH_RESULT,
    payload: {},
  };
}

/*
 * Search contact list
 */
export function searchContactLists(query, page, limit, highlight) {
  return function (dispatch) {
    dispatch(searchingContactLists(query, page));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `contacts/${page}`,
    });

    let param = {
      query: query,
      limit: limit,
      type: "contact_list",
      highlight: highlight,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingContactListsSuccedded(query, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searchingContactListsFailed(query));
      });
  };
}

function searchingContactLists(query, page) {
  return {
    type: SEARCHING_CONTACT_LIST,
    payload: {
      query: query,
      currentPage: page,
    },
  };
}

function searchingContactListsSuccedded(query, response) {
  return {
    type: SEARCHING_CONTACT_LIST_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingContactListsFailed(query) {
  return {
    type: SEARCHING_CONTACT_LIST_FAILED,
    payload: {
      query: query,
    },
  };
}

export function invalidateContactListsSearchResult() {
  return {
    type: INVALIDATE_CONTACT_LIST,
    payload: {},
  };
}

/*
 * Search Contact for AutoComplete
 */
export function searchContactForAutoComplete(query, type) {
  return function (dispatch) {
    dispatch(searchingContactForAutoComplete(query));

    let param = {
      type: type || "both",
      global: false,
      query: query,
      page: 0,
      limit: 25,
    };

    return axios({
      method: "GET",
      url: CONTACT_BASE_URL,
      params: param,
    })
      .then((response) => {
        return dispatch(
          searchingContactForAutoCompleteSuccedded(query, response.data)
        );
      })
      .catch((error) => {
        console.log(error);
        return dispatch(searhchingContactForAutoCompleteFailed(query));
      });
  };
}

function searchingContactForAutoComplete(query) {
  return {
    type: SEARCHING_CONTACT_FOR_AUTOCOMPLETE,
    payload: query,
  };
}

function searchingContactForAutoCompleteSuccedded(query, json) {
  return {
    type: SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED,
    payload: {
      query: query,
      result: json,
    },
  };
}

function searhchingContactForAutoCompleteFailed(query, error) {
  return {
    type: SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED,
    payload: {
      query: query,
      error: error,
    },
  };
}

export function invalidateAutoCompleteContact() {
  return {
    type: INVALIDATE_AUTOCOMPLETE_CONTACT,
    payload: {},
  };
}

/*
 * Fetch tags
 */

export function fetchTags(query, filter) {
  return function (dispatch) {
    dispatch(fetchingTags());

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `assets/tags`,
    });

    var additionalFilters = filter || {};

    var streams = [];
    if (filter && filter.streams) {
      streams = filter.streams;
    }

    var customFields = null;
    if (filter && filter.customFields) {
      customFields = JSON.stringify(filter.customFields);
    }

    let param = {
      ...additionalFilters,
      query: query,
      streams: streams,
      customFields: customFields,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(fetchingTagsSuccedded(response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingTagsFailed(error));
      });
  };
}

function fetchingTags() {
  return {
    type: FETCHING_TAGS,
    payload: {},
  };
}

function fetchingTagsSuccedded(json) {
  return {
    type: FETCHING_TAGS_SUCCEDDED,
    payload: json,
  };
}

function fetchingTagsFailed() {
  return {
    type: FETCHING_TAGS_FAILED,
    payload: {},
  };
}

export function invalidateTags(error) {
  return {
    type: INVALIDATE_TAGS,
    payload: error,
  };
}

/*
 * Fetch Asset details
 */

export function fetchAssetDetail(asset) {
  return function (dispatch) {
    dispatch(fetchingAssetDetail());

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `assets/${asset.id}/details`,
    });

    let collections = asset.collections.slice(0, 100);

    let param = {
      stream: asset.streams.join(),
      collection: collections.join(),
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(fetchingAssetDetailSuccedded(response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(fetchingAssetDetailFailed());
      });
  };
}

function fetchingAssetDetail() {
  return {
    type: SEARCHING_ASSET_DETAIL,
    payload: {},
  };
}

function fetchingAssetDetailSuccedded(json) {
  return {
    type: SEARCHING_ASSET_DETAIL_SUCCEDDED,
    payload: json,
  };
}

function fetchingAssetDetailFailed(error) {
  return {
    type: SEARCHING_ASSET_DETAIL_FAILED,
    payload: error,
  };
}

export function fetchingAssetDetailTags() {
  return {
    type: INVALIDATE_ASSET_DETAIL_SEARCH_RESULT,
    payload: {},
  };
}

/**
 * Search Users
 *
 */
export function searchUsers(query, page, limit, ignoreMe) {
  return function (dispatch) {
    dispatch(searchingUsers(query, page));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `users/${page}`,
    });

    let param = {
      query: query,
      limit: limit,
      ignoreMe: ignoreMe,
    };

    return axios({
      method: "GET",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingUsersSuccedded(query, response.data));
      })
      .catch((error) => {
        return dispatch(searchingUsersFailed(query, error));
      });
  };
}

function searchingUsers(query, page) {
  return {
    type: SEARCHING_USERS_REQUEST,
    payload: {
      query: query,
      currentPage: page,
    },
  };
}

function searchingUsersSuccedded(query, response) {
  return {
    type: SEARCHING_USERS_SUCCEDDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function searchingUsersFailed(query, error) {
  return {
    type: SEARCHING_USERS_FAILED,
    payload: {
      query: query,
      error: error,
    },
  };
}

/*
 * Fetch User Groups
 */
export function searchUserGroupForAutoComplete(query, showAll) {
  return function (dispatch) {
    dispatch(searchingUserGroupsForAutoComplete());

    let param = {
      query: query,
      page: 0,
      showAll: showAll,
    };

    return axios({
      method: "GET",
      url: USER_GROUPS_URL,
      params: param,
    })
      .then((response) => {
        return dispatch(searchingUserGroupsSuccedded(response.data));
      })
      .catch((error) => {
        return dispatch(searchingUserGroupsFailed(error));
      });
  };
}

function searchingUserGroupsForAutoComplete() {
  return {
    type: SEARCHING_USER_GROUPS_REQUEST,
    payload: {},
  };
}

function searchingUserGroupsSuccedded(json) {
  return {
    type: SEARCHING_USER_GROUPS_SUCCEDDED,
    payload: json,
  };
}

function searchingUserGroupsFailed(error) {
  return {
    type: SEARCHING_USER_GROUPS_FAILED,
    payload: error,
  };
}

export function invalidateAutoCompleteUserGroup() {
  return {
    type: INVALIDATE_AUTOCOMPLETE_USER_GROUP,
    payload: {},
  };
}

/*
 * Record search query
 */
export function recordSearchQuery(context) {
  return function (dispatch) {
    dispatch(recordingSearchQuery(context));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `record`,
    });

    return axios({
      method: "POST",
      url: url,
      data: context,
    })
      .then((response) => {
        return dispatch(recordingSearchQuerySuccedded(context, response.data));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(recordingSearchQueryFailed(context, error));
      });
  };
}

function recordingSearchQuery(context) {
  return {
    type: RECORDING_SEARCH_QUERY_REQUEST,
    payload: {
      context: context,
    },
  };
}

function recordingSearchQuerySuccedded(context, response) {
  return {
    type: RECORDING_SEARCH_QUERY_SUCCEDDED,
    payload: {
      context: context,
    },
  };
}

function recordingSearchQueryFailed(context, error) {
  return {
    type: RECORDING_SEARCH_QUERY_FAILED,
    payload: {
      context: context,
    },
  };
}

/*
 * Notify Content Moderator
 */
export function notifyContentModerator(query) {
  return function (dispatch) {
    dispatch(notifyingContentModerator(query));

    let url = buildUrl(SEARCH_BASE_URL, {
      path: `content-moderator/notify`,
    });

    let param = {
      query: query,
    };

    return axios({
      method: "POST",
      url: url,
      params: param,
    })
      .then((response) => {
        return dispatch(notifyingContentModeratorSucceeded(query, response));
      })
      .catch((error) => {
        console.log(error);
        return dispatch(notifyingContentModeratorFailed(query, error));
      });
  };
}

function notifyingContentModerator(query) {
  return {
    type: NOTIFY_CONTENT_MODERATOR_REQUEST,
    payload: {
      query: query,
    },
  };
}

function notifyingContentModeratorSucceeded(query, response) {
  return {
    type: NOTIFYING_CONTENT_MODERATOR_SUCCEEDED,
    payload: {
      query: query,
      result: response,
    },
  };
}

function notifyingContentModeratorFailed(query, error) {
  return {
    type: NOTIFYING_CONTENT_MODERATOR_FAILED,
    payload: {
      query: query,
      error: error,
    },
  };
}

// search opportunity recommended assets
export function searchOpportunityRecommendedAssets(oppostunityId) {
  return function (dispatch) {
    dispatch(searchingOpportunityRecommendedAssets());

    let url = buildUrl(CRM_BASE_URL, {
      path: `opportunities/${oppostunityId}/recommended-assets`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => {
        return dispatch(
          searchingOpportunityRecommendedAssetsSucceeded(response)
        );
      })
      .catch((error) => {
        return dispatch(searchingOpportunityRecommendedAssetsFailed(error));
      });
  };
}

export function searchOpportunityRecommendedStreams(oppostunityId){
  return function (dispatch) {
    dispatch(searchingOpportunityRecommendedStreams());

    let url = buildUrl(CRM_BASE_URL, {
      path: `opportunities/${oppostunityId}/recommended-streams`,
    });
    return axios({
      method: "GET",
      url: url,
    })
    .then((response) => {
      return dispatch(
        searchingOpportunityRecommendedStreamsSucceeded(response)
      );
    })
    .catch((error) => {
      return dispatch(searchingOpportunityRecommendedStreamsFailed(error));
    });

  };

}

function searchingOpportunityRecommendedStreams(){
  return {
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST,
    payload:{}
  };

}

function searchingOpportunityRecommendedStreamsSucceeded(response) {
  return{
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED,
    payload: response,

  };

}

function searchingOpportunityRecommendedStreamsFailed(error) {
  return{
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED,
    payload: error
  };

}


function searchingOpportunityRecommendedAssets() {
  return {
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
    payload: {},
  };
}

function searchingOpportunityRecommendedAssetsSucceeded(response) {
  return {
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
    payload: response,
  };
}

function searchingOpportunityRecommendedAssetsFailed(error) {
  return {
    type: SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
    payload: error,
  };
}

//search opportunity shared assets for msdynamics
export function searchMsDynamicsOpportunityRecommendedAssets(opportunityId) {
  return function (dispatch) {
    dispatch(searchingMsDynamicsOpportunityRecommendedAssets());

    let url = buildUrl(INTEGRATION_BASE_URL, {
      path: `ms-dynamics/opportunities/${opportunityId}/recommended-assets`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => {
        return dispatch(
          searchingMsDynamicsOpportunityRecommendedAssetsSucceeded(response)
        );
      })
      .catch((error) => {
        return dispatch(searchingMsDynamicsOpportunityRecommendedAssetsFailed(error));
      });
  };
}

function searchingMsDynamicsOpportunityRecommendedAssets() {
  return {
    type: SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
    payload: {},
  };
}

function searchingMsDynamicsOpportunityRecommendedAssetsSucceeded(response) {
  return {
    type: SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
    payload: response,
  };
}

function searchingMsDynamicsOpportunityRecommendedAssetsFailed(error) {
  return {
    type: SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
    payload: error,
  };
}


// search opportunity shared assets
export function searchOpportunitySharedAssets(oppostunityId) {
  return function (dispatch) {
    dispatch(searchingOpportunitySharedAssets());

    let url = buildUrl(CRM_BASE_URL, {
      path: `opportunities/${oppostunityId}/shared-assets`,
    });

    return axios({
      method: "GET",
      url: url,
    })
      .then((response) => {
        return dispatch(searchingOpportunitySharedAssetsSucceeded(response));
      })
      .catch((error) => {
        return dispatch(searchingOpportunitySharedAssetsFailed(error));
      });
  };
}

function searchingOpportunitySharedAssets() {
  return {
    type: SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST,
    payload: {},
  };
}

function searchingOpportunitySharedAssetsSucceeded(response) {
  return {
    type: SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED,
    payload: response,
  };
}

function searchingOpportunitySharedAssetsFailed(error) {
  return {
    type: SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED,
    payload: error,
  };
}

// generate anwser for query using openai
export function seekAnswerForQuestion(session, question, assetId) {
  return function (dispatch) {
    var data = {
      question: question,
      querying: true
    };

    if(session){
      data.session = session;
    }


    if(assetId){
      data = {
        ...data,
        content: {
          type: 'asset',
          id: assetId
        }
      }
    }

    dispatch(seekAnswerForQuestionRequest(session, question));

    return axios({
      method: "POST",
      url: SEEK_URL,
      data: data,
    })
      .then((response) => {
        return dispatch(seekAnswerForQuestionSucceeded(session, response.data));
      })
      .catch((error) => {
        return dispatch(seekAnswerForQuestionFailed(session, error, question));
      });
  };
}

// generate anwser for query using openai
export function fetchSeekSummary(session, question, assetId) {
  //query, seekQASessionId
  return function (dispatch) {
    const data = {
      question: question,
      session: session,
      querying: true,
      content: {
        type: 'asset',
        id: assetId
      }
    };

    dispatch(fetchSeekSummaryRequest(session, question));

    let url = buildUrl(SEEK_URL, {
      path: `asset_summary`,
    });
    return axios({
      method: "POST",
      url: url,
      data: data,
    })
      .then((response) => {
        return dispatch(fetchingSeekSummarySucceeded(session, response.data));
      })
      .catch((error) => {
        return dispatch(fetchingSeekSummaryFailed(session, error, question));
      });
  };
}

function fetchSeekSummaryRequest(id, question) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_REQUEST,
    payload: { id, question }
  };
}

function fetchingSeekSummarySucceeded(id, response) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_SUCCEEDED,
    payload: { id, response }
  };
}

function fetchingSeekSummaryFailed(id, error, question) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_FAILED,
    payload: { id, error, question }
  };
}

// generate anwser for query using openai
export function generateAnswerForAsset(account, asset, query, context) {
  return function (dispatch) {
    dispatch(seekAnswerForQuestionRequest(query));

    let url = buildUrl(SEEK_URL, {
      path: `${account}/assets/${asset}`,
    });

    const data = {
      query: query,
      past_context: context,
    };

    return axios({
      method: "POST",
      url: url,
      data: data,
    })
      .then((response) => {
        return dispatch(seekAnswerForQuestionSucceeded(response.data));
      })
      .catch((error) => {
        return dispatch(seekAnswerForQuestionFailed(error));
      });
  };
}

function seekAnswerForQuestionRequest(id, question) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_REQUEST,
    payload: {id, question}
  };
}

function seekAnswerForQuestionSucceeded(id, response) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_SUCCEEDED,
    payload: {id, response}
  };
}

function seekAnswerForQuestionFailed(id, error , question) {
  return {
    type: SEEK_ANSWER_FOR_QUESTION_FAILED,
    payload: {id, error, question}
  };
}

export function fetchSeekQASessions(page, limit) {
  return function (dispatch) {
    let url = buildUrl(SEEK_URL, {
      path: `sessions`,
    });

    let params = {
      page,
      limit,
    };

    dispatch(fetchingSeekQASessions({ page, limit }));

    return axios({
      method: "GET",
      url: url,
      params: params,
    })
      .then((response) => {
        return dispatch(fetchingSeekQASessionsSucceeded(response.data));
      })
      .catch((error) => {
        return dispatch(fetchingSeekQASessionsFailed(error));
      });
  };
}

function fetchingSeekQASessions({ page, limit }) {
  return {
    type: FETCHING_SEEKQA_SESSIONS,
    payload: { page, limit },
  };
}

function fetchingSeekQASessionsSucceeded(response) {
  return {
    type: FETCHING_SEEKQA_SESSIONS_SUCCEEDED,
    payload: response,
  };
}

function fetchingSeekQASessionsFailed(error) {
  console.log(error);

  return {
    type: FETCHING_SEEKQA_SESSIONS_FAILED,
    payload: error,
  };
}

export function fetchSeekQAChats(session, page, limit) {
  return function (dispatch) {
    let url = buildUrl(SEEK_URL, {
      path: `sessions/${session.id}/chats`,
    });

    let params = {
      page,
      limit,
    };

    dispatch(fetchingSeekQAChats(session, page, limit));

    return axios({
      method: "GET",
      url: url,
      params: params,
    })
      .then((response) => {
        return dispatch(fetchingSeekQAChatsSucceeded(session, response.data));
      })
      .catch((error) => {
        return dispatch(fetchingSeekQAChatsFailed(session, error));
      });
  };
}

function fetchingSeekQAChats(session, page, limit) {
  return {
    type: FETCHING_SEEKQA_CHATS,
    payload: { session, page, limit },
  };
}

function fetchingSeekQAChatsSucceeded(session, response) {

  return {
    type: FETCHING_SEEKQA_CHATS_SUCCEEDED,
    payload: {session, response}
  };
}

function fetchingSeekQAChatsFailed(session, error) {
  console.log("error: ", error);

  return {
    type: FETCHING_SEEKQA_CHATS_FAILED,
    payload: {session, error}
  };
}

export function deleteSeekQASession(id) {
  return function (dispatch) {
    let url = buildUrl(SEEK_URL, {
      path: `sessions/${id}`,
    });

    dispatch(deletingSeekQASession());

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        return dispatch(deletingSeekQASessionSucceeded(response.data));
      })
      .catch((error) => {
        return dispatch(deletingSeekQASessionFailed(error));
      });
  };
}

function deletingSeekQASession() {
  return {
    type: DELETING_SEEKQA_SESSION,
  };
}

function deletingSeekQASessionSucceeded(response) {
  return {
    type: DELETING_SEEKQA_SESSION_SUCCEEDED,
    payload: response,
  };
}

function deletingSeekQASessionFailed(error) {
  return {
    type: DELETING_SEEKQA_SESSION_FAILED,
    payload: error,
  };
}

export function deleteSeekQASessions() {
  return function (dispatch) {
    let url = buildUrl(SEEK_URL, {
      path: `sessions`,
    });

    dispatch(deletingSeekQASessions());

    return axios({
      method: "DELETE",
      url: url,
    })
      .then((response) => {
        return dispatch(deletingSeekQASessionsSucceeded(response.data));
      })
      .catch((error) => {
        return dispatch(deletingSeekQASessionsFailed(error));
      });
  };
}

function deletingSeekQASessions() {
  return {
    type: DELETING_SEEKQA_SESSIONS,
  };
}

function deletingSeekQASessionsSucceeded(response) {
  return {
    type: DELETING_SEEKQA_SESSIONS_SUCCEEDED,
    payload: response,
  };
}

function deletingSeekQASessionsFailed(error) {
  return {
    type: DELETING_SEEKQA_SESSIONS_FAILED,
    payload: error,
  };
}

export function invalidateSeekSession() {
  return {
    type: INVALIDATE_SEEK_SESSION,
  };
}

// fetching seekqa suggestions
export function fetchSeekQASuggestions() {
  return function (dispatch) {
    let url = buildUrl(SEEK_URL, {
      path: `suggestions`,
    });

    dispatch(fetchingSeekQASuggestions());

    return axios({
      method: "GET",
      url: url
    })
      .then((response) => {
        return dispatch(fetchingSeekQASuggestionsSucceeded(response.data));
      })
      .catch((error) => {
        return dispatch(fetchingSeekQASuggestionsFailed(error));
      });
  };
}

function fetchingSeekQASuggestions() {
  return {
    type: FETCHING_SEEKQA_SUGGESTIONS
  };
}

function fetchingSeekQASuggestionsSucceeded(response) {
  return {
    type: FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED,
    payload: response,
  };
}

function fetchingSeekQASuggestionsFailed(error) {
  console.log(error);

  return {
    type: FETCHING_SEEKQA_SUGGESTIONS_FAILED,
    payload: error,
  };
}

export function updateSeekHelful(chatId, isHelpful) {
  return function (dispatch) {
    
    const data = {
      isHelpful: isHelpful
    }

    let url = buildUrl(SEEK_URL, {
      path: `/chats/${chatId}/feedback`,
    });

    dispatch(updatingSeekHelpful(chatId));

    return axios({
      method: "PUT",
      url: url,
      params: data
    })
      .then((response) => {
        return dispatch(updatingSeekHelpfulSucceeded(chatId, response.data));
      })
      .catch((error) => {
        return dispatch(updatingSeekHelpfulFailed(chatId, error));
      });
  };
}

function updatingSeekHelpful(id) {
  return {
    type: UPDATING_SEEK_HELPFUL,
    payload: {id}
  };
}

function updatingSeekHelpfulSucceeded(id, response) {
  return {
    type: UPDATING_SEEK_HELPFUL_SUCCEEDED,
    payload: {id, response}
  };
}

function updatingSeekHelpfulFailed(id, error) {
  console.log(error);

  return {
    type: UPDATING_SEEK_HELPFUL_FAILED,
    payload: {id, error}
  };
}

export function fetchEmailForSeekResponse(id, chatId){
  return function (dispatch){
    let url = buildUrl(SEEK_URL,{
      path: `sessions/${id}/chats/${chatId}/email`,
    })

  dispatch(fetchingEmailForSeekResponse());

  return axios({
    method: "GET",
    url: url
  })
    .then((response) => {
      return dispatch(fetchingEmailForSeekResponseSucceeded(response.data));
    })
    .catch((error) => {
      return dispatch(fetchingEmailForSeekResponseFailed(error));
    });
}
  }

function fetchingEmailForSeekResponse(){
  return{
    type: FETCHING_EMAIL_FOR_SEEK_RESPONSE,
  }
}

function fetchingEmailForSeekResponseSucceeded(response){
  return {
    type: FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED,
    payload: response
  }
}

function fetchingEmailForSeekResponseFailed(error){
  return {
    type: FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED,
    payload: error,
  };
}



export function fetchSeekLimit(){
  return function (dispatch){
    let url = buildUrl(SEEK_URL,{
      path: `limit/validate`,
    })

  dispatch(fetchingSeekLimit());

  return axios({
    method: "GET",
    url: url
  })
    .then((response) => {
      return dispatch(fetchingSeekLimitSucceded(response.data));
    })
    .catch((error) => {
      return dispatch(fetchingSeekLimitFailed(error));
    });
}
  }

function fetchingSeekLimit(){
  return{
    type: FETCHING_SEEK_LIMIT,
  }
}

function fetchingSeekLimitSucceded(response) {
  return {
    type: FETCHING_SEEK_LIMIT_SUCCEEDED,
    payload: response
  }
}

function fetchingSeekLimitFailed(error) {
  return {
    type: FETCHING_SEEK_LIMIT_FAILED,
    payload: error,
  };
}

export function fetchSeekQuestionCount(){
  return function (dispatch){
    let url = buildUrl(SEEK_URL,{
      path: `/limit`,
    })

  dispatch(fetchingSeekQuestionCount());

  return axios({
    method: "GET",
    url: url
  })
    .then((response) => {
      return dispatch(fetchingSeekQuestionCountSucceded(response.data));
    })
    .catch((error) => {
      return dispatch(fetchingSeekQuestionCountFailed(error));
    });
  }
}

function fetchingSeekQuestionCount(){
  return{
    type: FETCHING_SEEK_QUESTION_COUNT,
  }
}

function fetchingSeekQuestionCountSucceded(response) {
  return {
    type: FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED,
    payload: response
  }
}

function fetchingSeekQuestionCountFailed(error) {
  return {
    type: FETCHING_SEEK_QUESTION_COUNT_FAILED,
    payload: error,
  };
}